<template>
    <a :href="linkApi" 
        :class="['btn btn-whatsapp', customClass]" 
        target="_blank"><i class="fa-brands fa-whatsapp"></i> {{ btnLabel }}</a>
</template>

<script>

    export default {
        props: {
            btnLabel: {
                type: String,
                required: true
            },
            phoneNumber: {
                type: String,
                required: true
            },
            textToSend: {
                type: String,
                required: true
            },
            customClass: String
        },
        computed: {
            linkApi() {
                return `https://wa.me/${ this.phoneNumber }?text=${ encodeURI(this.textToSend) }`
            }
        }
    }
</script>

<style lang="less" scoped>

    .btn-whatsapp {
        color: #fff;
        background: #25d366;

        > .fa {
            margin-right: 10px;
        }
        
        &:hover {
            background: #128c7e;
        }
    }
</style>